<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
<!--        <preLoader v-if="loader"></preLoader>-->
        <div class="container">
            <div class="form-group" style="margin-top: 30px">

              <b-row>


                <b-col>
                <router-link :to="{path: '/flow/create'}" class="btn btn-success">Add Flow (گردش)</router-link>
<!--                <button type="button" class="btn btn-default" style="float: left"-->
<!--                        v-on:click="tableToExcel('testTable', 'W3C Example Table')" >{{ $t('Excel Output List') }}</button>-->

                </b-col>

              <b-col col="2">
                <b-form-select   style="direction: ltr"
                                v-model="processId" @change="getFlows()"
                >
                  <b-form-select-option  v-for="(process, processIndex) in processes" :key="processIndex"
                                         :value="process.id"  >
                    {{process.title}}
                  </b-form-select-option>

                </b-form-select>
              </b-col>


              </b-row>
            </div>



            <div class="panel panel-default ">
                <div class="panel-heading"></div>
                <div class="panel-body  ">
                    <div class="table-responsive">



                        <table   id="testTable"  class="table table-bordered table-striped table-hover">
                            <thead>
                            <tr>



                                <th>ردیف </th>
                                <th>عنوان  </th>

                                <th>فرایند </th>
<!--                                <th>نوع </th>-->
                                <th>وضعیت </th>
                                <th>فیلد ها </th>

                                <th width="100">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr id="items" v-for="(item, index) in items" :key="index">
                                <td>{{index+1 }}</td>

<!--                                <td > <span v-if="item.process">{{ item.process.title }}</span></td>-->

                                <td>{{ item.title }}</td>

                                <td>
                                    <span v-if="item.process">{{item.process.title}}</span>
                                </td>

<!--                                <td>-->
<!--                                    <span v-if="item.issue_type">{{item.issue_type.title}}</span>-->
<!--                                </td>-->
                                <td>{{ item.state}}</td>
                                <td>

                                    <CButton
                                            @click="manageConditions(item.id)"
                                            color="primary"
                                            class="btn-sm text-left m-1"
                                    >
                                         مدیریت شروط
                                         و عملیات
                                    </CButton>



                                </td>

                                <!--<td v-text="filteritem(item.state)">{{ item.state  }}</td>-->

                                <td>
                                    <router-link :to="{path: '/flow/edit/'+item.id, params: {id: item.id}}"
                                                 class="btn btn-sm btn-default m-1 ">
                                        {{ $t('Edit') }}
                                    </router-link>
                                    <a href="javascript: void(0)" class="btn btn-sm btn-danger m-1 "
                                       v-on:click="deleteEntry(item.id, index)">
                                        حذف
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Trigger the modal with a button -->

                        <!-- Modal -->

                    </div>
                </div>
            </div>
            <div class="col-xs-12 text-center">
                <pagination v-if="processId" :api="`/api/flows?process_id=`+processId" @pagnationChangeDate='pagnation'></pagination>

            </div>







            <b-modal :id="'conditions-manage-'+item.id" v-for="(item, modalIndex) in items" :key="'modal-'+modalIndex"   size="xl"
                 class="modal fade" role="dialog">

                    <!-- Modal content-->
                    <div class="">



                            <div class="modal-header ">
                                <h4 class="modal-title">Conditions  </h4>
                            </div>
                            <div class="modal-body">

                                <table class="table table-striped table-bordered table-sm">
                                    <thead>
                                    <tr>
                                        <th scope="col">
                                            <b-btn @click="addConditions()" size="sm" variant="success">
                                                <i class="fa fa-plus"></i>
                                            </b-btn>
                                        </th>
                                        <th >نوع شرط</th>
                                        <th >AND/OR</th>
                                        <th >نوع فیلد</th>
                                        <th >فیلد</th>
                                        <th scope="col">عملگر</th>
                                        <th scope="col">مقدار</th>
                                        <th scope="col"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(condition , conditionIndex) in conditions" :key="conditionIndex">
                                        <th scope="row">{{conditionIndex+1}}</th>
                                        <td>
                                            <b-form-select v-model="condition.type"  class="form-control form-control-sm">
                                                <b-form-select-option  value="all" >تمام Issue ها</b-form-select-option>
                                                <b-form-select-option disabled  value="specific" >Issue خاص</b-form-select-option>
                                            </b-form-select>
                                        </td>
                                        <td>

                                            <b-form-select v-model="condition.operator" style="direction: ltr"  class="form-control form-control-sm">
                                                <b-form-select-option  value="and" >AND</b-form-select-option>
                                                <b-form-select-option  value="or" >OR</b-form-select-option>
                                            </b-form-select>

                                        </td>
                                        <td>
                                            <b-form-select v-model="condition.field_type"  class="form-control form-control-sm" >
                                                <b-form-select-option  value="internal"  >فیلدهای اصلی</b-form-select-option>
                                                <b-form-select-option  value="external" >فیلدهای فرعی</b-form-select-option>
                                            </b-form-select>
                                        </td>
                                        <td>
                                            <b-form-select v-if="condition.field_type === 'external'" v-model="condition.field"  class="form-control form-control-sm" >
                                                <b-form-select-option  v-for="(field, fieldIndex) in fields" :key="fieldIndex" :value="field.id" >
                                                    {{field.title}}
                                                </b-form-select-option>
                                            </b-form-select>

                                            <b-form-select v-else v-model="condition.field"  class="form-control form-control-sm" >
                                                <b-form-select-option  value="title"  > عنوان</b-form-select-option>
                                                <b-form-select-option  value="intro"  > توضیحات</b-form-select-option>
                                                <b-form-select-option  value="type"  > نوع</b-form-select-option>
                                                <b-form-select-option  value="board_id"  > وضعیت</b-form-select-option>
                                                <b-form-select-option  value="priority"  > اولویت</b-form-select-option>
                                                <b-form-select-option  value="contact_id"  > مشتری</b-form-select-option>
                                                <b-form-select-option  value="project_id"  > پروژه</b-form-select-option>
<!--                                                <b-form-select-option  value="process_id"  > فرایند</b-form-select-option>-->
                                                <b-form-select-option  value="step_id"  > مرحله</b-form-select-option>
                                                <b-form-select-option  value="start_date"  >  زمان شروع</b-form-select-option>
                                                <b-form-select-option  value="done_date"  > زمان انجام</b-form-select-option>
                                                <b-form-select-option  value="estimated_time"  > مدت تخمینی</b-form-select-option>
                                                <b-form-select-option  value="progress_input"  > درصد پیشرفت</b-form-select-option>
                                                <b-form-select-option  value="created_by"  > ایجاد توسط</b-form-select-option>
                                                <b-form-select-option  value="created_at"  > تاریخ ثبت</b-form-select-option>
                                            </b-form-select>
                                        </td>
                                        <td >

                                            <b-form-select v-model="condition.condition"  class="form-control-sm">
                                                <b-form-select-option  value="==" >مساوی</b-form-select-option>
                                                <b-form-select-option  value="!=" >نامساوی</b-form-select-option>
                                                <b-form-select-option  value=">" >کوچکتر</b-form-select-option>
                                                <b-form-select-option  value=">=" >کوچکتر مساوی</b-form-select-option>
                                                <b-form-select-option  value="<" >بزرگتر</b-form-select-option>
                                                <b-form-select-option  value="<=" >بزرگتر مساوی</b-form-select-option>
                                                <b-form-select-option  value="like" > شامل شود</b-form-select-option>
                                                <b-form-select-option  value="!like" > شامل نشود</b-form-select-option>
                                                <b-form-select-option  value="null" >  خالی باشد</b-form-select-option>
                                                <b-form-select-option  value="!null" >  خالی نباشد</b-form-select-option>
                                            </b-form-select>
                                        </td>
                                        <td >




                                          <b-form-select v-if="condition.field === 'type'" v-model="condition.value"  size="sm" class="mt-2" style="direction: ltr">
                                            <b-form-select-option  v-for="(type, typeIndex) in types" :key="typeIndex"  :style="{color: typeBadgeStyles(type)}"
                                                                   :value="type.id"  > {{type.title}}
                                            </b-form-select-option>
                                            <b-form-select-option  value="0" style="color: #888888">سایر</b-form-select-option>
                                          </b-form-select>

                                          <b-form-select  v-else-if="condition.field === 'board_id'"  v-model="condition.value"  size="sm" class="mt-2"  style="direction: ltr">
                                            <b-form-select-option  value="1"  style="color: #ffab00">(Open) باز شده</b-form-select-option>
                                            <b-form-select-option  value="2"  style="color: #ffd600">(To DO) جهت انجام</b-form-select-option>
                                            <b-form-select-option  value="3"  style="color: #aeea00">درحال انجام (Doing)</b-form-select-option>
                                            <!--                        <b-form-select-option  value="4"  style="color: #64dd17">جهت بازبینی (Review)</b-form-select-option>-->
                                            <b-form-select-option  value="4"  style="color: #00bfa5">انجام شده (Done)</b-form-select-option>
                                            <b-form-select-option  value="5"  style="color: #64dd17">آرشیو (Archived)</b-form-select-option>
                                          </b-form-select>


                                          <b-form-select  v-else-if="condition.field === 'step_id'" size="sm" style="direction: ltr"
                                                          v-model="condition.value">
                                            <b-form-select-option  v-for="(step, stepIndex) in steps" :key="stepIndex"   :value="step.id" >
                                              {{step.title}}
                                            </b-form-select-option>
                                          </b-form-select>


                                          <b-form-select  v-else-if="condition.field === 'priority'" title="اولویت" v-model="condition.value"  size="sm" class="mt-2"  style="direction: ltr">
                                            <b-form-select-option  value="3" >  اولویت زیاد</b-form-select-option>
                                            <b-form-select-option  value="2" >  اولویت متوسط</b-form-select-option>
                                            <b-form-select-option  value="1" >  اولویت کم</b-form-select-option>
                                          </b-form-select>


                                          <v-select v-else-if="condition.field === 'contact_id'"
                                              v-model="condition.value"
                                              :options="contacts" label="last_name" :reduce="contact => contact.id" value="id">
                                          </v-select>


                                          <v-select v-else-if="condition.field === 'project_id'"
                                              v-model="condition.value"
                                              :options="projects" label="title" :reduce="project => project.id" value="id">
                                          </v-select>


                                          <!-- add created_by and created_at input -->


                                          <input v-else class="form-control form-control-sm" v-model="condition.value"
                                                   type="text" data-type="text">
                                        </td>
                                        <td>
                                        <span @click="deleteConditions(conditionIndex)">
                                             <i class="fa fa-times"></i>
                                        </span>
                                        </td>
                                    </tr>

                                    </tbody>
                                </table>




                            </div>
                            <div class="modal-footer">
<!--                                <button type="button" class="btn btn-default"-->
<!--                                        data-dismiss="modal">{{ $t('Close') }}</button>-->
                                <button class="btn btn-primary" data-dismiss="modal"
                                        @click="updateConditions(item.id)" >بروزرسانی شروط</button>
                            </div>



                    </div>


                <div class="">



                    <div class="modal-header ">
                        <h4 class="modal-title">Actions  </h4>
                    </div>
                    <div class="modal-body">

                        <table class="table table-striped table-bordered table-sm">
                            <thead>
                            <tr>
                                <th scope="col">
                                    <b-btn @click="addActions()" size="sm" variant="success">
                                        <i class="fa fa-plus"></i>
                                    </b-btn>
                                </th>
                                <th > </th>
                                <th ></th>
                                <th scope="col"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(action , actionIndex) in actions" :key="actionIndex">
                                <td>{{actionIndex+1}}</td>
                                <td>
                                    <small>  نوع Action:</small>
                                    <b-form-select v-model="action.type"  class="form-control form-control-sm">
                                        <b-form-select-option  value="message" >ارسال پیام (Email/SMS)</b-form-select-option>
                                        <b-form-select-option   value="update" >آپدیت فیلد </b-form-select-option>
                                        <b-form-select-option   value="assign" >تخصیص کاربر </b-form-select-option>
                                        <b-form-select-option  value="createIssue" >Issue ایجاد </b-form-select-option>
                                    </b-form-select>
                                </td>

                                <td  v-if="action.type === 'message'" >
                                    <b-row>

                                        <b-col>
                                            <b-textarea title="متن پیام"
                                                        v-model="action.new_reminder" id="textarea-rows" class="my-1 mt-2"
                                                        placeholder="متن پیام ..." rows="2"
                                            ></b-textarea>
                                        </b-col>
                                    </b-row>
                                    <b-row>

                                        <b-col>
                                            <small>  نوع پیام:</small>
                                            <b-form-select v-model="action.message_type"  class="form-control form-control-sm">
                                                <b-form-select-option  value="['db']" >  اعلان</b-form-select-option>
                                                <b-form-select-option  value="['db','sms']" >    اعلان و Email </b-form-select-option>
                                                <b-form-select-option  value="['db','email']" >   اعلان و SMS  </b-form-select-option>
                                                <b-form-select-option  value="['db','sms','email']" >اعلان و SMS و Email   </b-form-select-option>
                                            </b-form-select>
                                        </b-col>
                                    <b-col>
                                        <small>  نوع ارسال:</small>
                                        <b-form-select v-model="action.send_type"  class="form-control form-control-sm">
                                            <b-form-select-option disabled  value="all" >ارسال به همه</b-form-select-option>
                                            <b-form-select-option  value="selected" >ارسال به کاربران خاص</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    </b-row>
                                    <b-row>
                                    <b-col v-if="action.send_type === 'selected'">
                                        <small>  کاربران:</small>
                                        <multiselect   v-model="action.send_users" :height="300" :options="assignOptions" :multiple="true"
                                                       :taggable="true" :close-on-select="false" :clear-on-select="false"
                                                       :custom-label="customLabelAssign"
                                                       :preserve-search="true" :hide-selected="true" :show-labels="false"
                                                       tag-placeholder=" کاربران" placeholder=" کاربران"
                                                       label="name" track-by="name" :preselect-first="false"
                                                       @tag="addAssign">

                                        </multiselect>
                                    </b-col>
                                    </b-row>
                                </td>
                                <td  v-else-if="action.type === 'update'" >
                                    <b-row>
                                        <b-col>
                                            <small> نوع فیلد:</small>
                                            <b-form-select v-model="action.field_type"  class="form-control form-control-sm" >
                                                <b-form-select-option  value="internal"  >فیلدهای اصلی</b-form-select-option>
                                                <b-form-select-option  value="external" >فیلدهای فرعی</b-form-select-option>
                                            </b-form-select>
                                        </b-col>
                                        <b-col  v-if="action.field_type === 'external'" >
                                            <small>  فیلد:</small>
                                            <b-form-select v-model="action.field"  class="form-control form-control-sm" >
                                                <b-form-select-option  v-for="(field, fieldIndex) in fields" :key="fieldIndex" :value="field.id" >
                                                    {{field.title}}
                                                </b-form-select-option>
                                            </b-form-select>
                                        </b-col>
                                        <b-col  v-else>
                                            <small>  فیلد:</small>
                                            <b-form-select  v-model="action.field"  class="form-control form-control-sm" >
                                                <b-form-select-option  value="title"  > عنوان</b-form-select-option>
                                                <b-form-select-option  value="intro"  > توضیحات</b-form-select-option>
                                                <b-form-select-option  value="type"  > نوع</b-form-select-option>
                                                <b-form-select-option  value="board_id"  > وضعیت</b-form-select-option>
                                                <b-form-select-option  value="priority"  > اولویت</b-form-select-option>
<!--                                                <b-form-select-option  value="contact_id"  > مشتری</b-form-select-option>-->
<!--                                                <b-form-select-option  value="project_id"  > پروژه</b-form-select-option>-->
<!--                                                <b-form-select-option  value="process_id"  > فرایند</b-form-select-option>-->
                                                <b-form-select-option  value="step_id"  > مرحله</b-form-select-option>
<!--                                                <b-form-select-option  value="start_date"  >  زمان شروع</b-form-select-option>-->
                                                <b-form-select-option  value="done_date"  > زمان انجام</b-form-select-option>
                                                <b-form-select-option  value="estimated_time"  > مدت تخمینی</b-form-select-option>
                                                <b-form-select-option  value="progress_input"  > درصد پیشرفت</b-form-select-option>
                                            </b-form-select>
                                        </b-col>











                                        <b-col>
                                            <small>  مقدار جدید:</small>


                                          <b-form-select v-if="action.field === 'type'" v-model="action.new_value"  size="sm" class="mt-2" style="direction: ltr">
                                            <b-form-select-option  v-for="(type, typeIndex) in types" :key="typeIndex"  :style="{color: typeBadgeStyles(type)}"
                                                                   :value="type.id"  > {{type.title}}
                                            </b-form-select-option>
                                            <b-form-select-option  value="0" style="color: #888888">سایر</b-form-select-option>
                                          </b-form-select>


                                          <b-form-select  v-else-if="action.field === 'board_id'"  v-model="action.new_value"  size="sm" class="mt-2"  style="direction: ltr">
                                            <b-form-select-option  value="1"  style="color: #ffab00">(Open) باز شده</b-form-select-option>
                                            <b-form-select-option  value="2"  style="color: #ffd600">(To DO) جهت انجام</b-form-select-option>
                                            <b-form-select-option  value="3"  style="color: #aeea00">درحال انجام (Doing)</b-form-select-option>
                                            <!--                        <b-form-select-option  value="4"  style="color: #64dd17">جهت بازبینی (Review)</b-form-select-option>-->
                                            <b-form-select-option  value="4"  style="color: #00bfa5">انجام شده (Done)</b-form-select-option>
                                            <b-form-select-option  value="5"  style="color: #64dd17">آرشیو (Archived)</b-form-select-option>
                                          </b-form-select>


                                          <b-form-select  v-else-if="action.field === 'step_id'" size="sm" style="direction: ltr"
                                                          v-model="action.new_value">
                                          <b-form-select-option  v-for="(step, stepIndex) in steps" :key="stepIndex"   :value="step.id" >
                                            {{step.title}}
                                          </b-form-select-option>
                                          </b-form-select>


                                          <b-form-select  v-else-if="action.field === 'priority'" title="اولویت" v-model="action.new_value"  size="sm" class="mt-2"  style="direction: ltr">
                                            <b-form-select-option  value="3" >  اولویت زیاد</b-form-select-option>
                                            <b-form-select-option  value="2" >  اولویت متوسط</b-form-select-option>
                                            <b-form-select-option  value="1" >  اولویت کم</b-form-select-option>
                                          </b-form-select>




                                          <input v-else  class="form-control form-control-sm" v-model="action.new_value"
                                                 type="text" data-type="text">



                                        </b-col>
                                    </b-row>
                                </td>
                                <td   v-else-if="action.type === 'assign'" >
                                    <b-row>

                                        <b-col>
                                            <small> اختصاص کاربر:</small>
                                            <multiselect   v-model="action.assign_users" :height="300" :options="assignOptions" :multiple="true"
                                                           :taggable="true" :close-on-select="false" :clear-on-select="false"
                                                           :custom-label="customLabelAssign"
                                                           :preserve-search="true" :hide-selected="true" :show-labels="false"
                                                           tag-placeholder="اختصاص کاربر" placeholder="اختصاص کاربر"
                                                           label="name" track-by="name" :preselect-first="false"
                                                           @tag="addAssign">

                                            </multiselect>
                                        </b-col>
                                        <b-col>
                                            <small> حذف کاربر:</small>
                                            <multiselect   v-model="action.conceal_users" :height="300" :options="assignOptions" :multiple="true"
                                                           :taggable="true" :close-on-select="false" :clear-on-select="false"
                                                           :custom-label="customLabelAssign"
                                                           :preserve-search="true" :hide-selected="true" :show-labels="false"
                                                           tag-placeholder="حذف کاربر" placeholder="حذف کاربر"
                                                           label="name" track-by="name" :preselect-first="false"
                                                           @tag="addAssign">

                                            </multiselect>
                                        </b-col>
                                    </b-row>
                                </td>

                              <td   v-else-if="action.type === 'createIssue'" >
                                <b-row>

                                  <b-col>

                                    <small>  ساخت Issue:</small>

                                    <div style="color: #555">

                                      <b-input
                                          v-model="action.new_issue.title" class="my-1 mt-2"
                                          placeholder="عنوان" rows="2" title="عنوان"
                                      ></b-input>
                                      <b-textarea v-if="action.new_issue.title" title="توضیحات"
                                                  v-model="action.new_issue.intro" id="textarea-rows" class="my-1 mt-2"
                                                  placeholder="توضیحات ..." rows="2"
                                      ></b-textarea>


                                      <b-row  v-if="action.new_issue.title">

                                        <b-col  md="5">
                                          <small> نوع:</small>

                                          <b-form-select v-model="action.new_issue.type"  size="sm" class="mt-2" style="direction: ltr">

                                            <b-form-select-option  v-for="(type, typeIndex) in types" :key="typeIndex"  :style="{color: typeBadgeStyles(type)}"
                                                                   :value="type.id"  >
                                              {{type.title}}
                                            </b-form-select-option>
                                            <b-form-select-option  value="0" style="color: #888888">سایر</b-form-select-option>

                                          </b-form-select>
                                        </b-col>

                                        <b-col  md="4">
                                          <small> وضعیت:</small>

                                          <b-form-select
                                              v-c-tooltip="{
        content: '<strong>وضعیت</strong>',
        placement: 'left'
      }"
                                              v-model="action.new_issue.board_id"  size="sm" class="mt-2"  style="direction: ltr">

                                            <b-form-select-option  value="1"  style="color: #ffab00">(Open) باز شده</b-form-select-option>
                                            <b-form-select-option  value="2"  style="color: #ffd600">(To DO) جهت انجام</b-form-select-option>
                                            <b-form-select-option  value="3"  style="color: #aeea00">درحال انجام (Doing)</b-form-select-option>
                                            <!--                        <b-form-select-option  value="4"  style="color: #64dd17">جهت بازبینی (Review)</b-form-select-option>-->
                                            <b-form-select-option  value="4"  style="color: #00bfa5">انجام شده (Done)</b-form-select-option>
                                            <!--                        <b-form-select-option  value="5"  style="color: #64dd17">آرشیو (Archived)</b-form-select-option>-->





                                          </b-form-select>
                                        </b-col>

                                        <b-col  md="3">
                                          <small> اولویت:</small>

                                          <b-form-select title="اولویت" v-model="action.new_issue.priority"  size="sm" class="mt-2"  style="direction: ltr">

                                            <b-form-select-option  value="3" >  اولویت زیاد</b-form-select-option>
                                            <b-form-select-option  value="2" >  اولویت متوسط</b-form-select-option>
                                            <b-form-select-option  value="1" >  اولویت کم</b-form-select-option>



                                          </b-form-select>
                                        </b-col>



                                        <b-col  md="4" class="mt-3 mb-2">
                                          <small> مشتری:</small>

                                          <v-select
                                              v-model="action.new_issue.contact_id"
                                              :options="contacts" label="last_name" :reduce="contact => contact.id" value="id">
                                          </v-select>


                                          <!--                            <multiselect  v-model="contact_id"  @select="setContactId()"    :options="contactOptions" :custom-label="customLabel"-->
                                          <!--                                         placeholder=" انتخاب مشتری" label="title" track-by="title">-->
                                          <!--                            </multiselect>-->
                                        </b-col>

                                        <b-col  md="3" class="mt-3 mb-2">
                                          <small> پروژه:</small>

                                          <v-select
                                              v-model="action.new_issue.project_id"
                                              :options="projects" label="title" :reduce="project => project.id" value="id">
                                          </v-select>

                                        </b-col>


                                        <b-col  md="5" class="mt-3 mb-2">
                                          <small> اختصاص کاربر:</small>

                                          <multiselect   v-model="action.new_issue.users" :height="300" :options="assignOptions" :multiple="true"
                                                         :taggable="true" :close-on-select="false" :clear-on-select="false"
                                                         :custom-label="customLabelAssign"
                                                         :preserve-search="true" :hide-selected="true" :show-labels="false"
                                                         tag-placeholder="اختصاص کاربر" placeholder="اختصاص کاربر"
                                                         label="name" track-by="name" :preselect-first="false"
                                                         @tag="addAssign">

                                          </multiselect>
                                        </b-col>

                                      </b-row>

                                    </div>



                                    <div class="row my-2">
                                      
                                      <b-row   v-if="action.new_issue.title" class="ul-upload mt-1 mb-0 col-6  text-left" style="color: #666">
<!--                                        <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showVoiceRecorder = !showVoiceRecorder"><i class="fas fa-microphone"></i></b-col>-->
<!--                                        <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showImageUploader = !showImageUploader"><i class="fas fa-image"></i></b-col>-->
<!--                                        <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showVideoUploader = !showVideoUploader"><i class="fas fa-film"></i></b-col>-->
<!--                                        <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showFileUploader = !showFileUploader"><i class="fas fa-paperclip"></i></b-col>-->
                                        <b-col class="li-upload mr-2"  >
                                          <b-button v-b-toggle.collapse-1  size="sm">
                                            <i class="fas fa-bars" aria-hidden="true"></i>
                                          </b-button>
                                        </b-col>
                                      </b-row>

                                      <div v-if="showVoiceRecorder" class="d-flex justify-content-center w-100 px-2 my-1">
                                        <!--                                                <audio-recorder-->
                                        <!--                                                        v-model="action.new_issue.voice"-->
                                        <!--                                                        :attempts="1"-->
                                        <!--                                                        :time="2"-->
                                        <!--                                                        :show-upload-button="false"-->
                                        <!--                                                        :before-recording="callback"-->
                                        <!--                                                        :pause-recording="callback"-->
                                        <!--                                                        :after-recording="callback"-->
                                        <!--                                                        :select-record="callback"-->
                                        <!--                                                        :before-upload="callback"-->
                                        <!--                                                        :successful-upload="callback"-->
                                        <!--                                                        :failed-upload="callback"/>-->

                                        <vue-record-audio  v-model="action.new_issue.voice" @result="onResult"  />

                                        <audio  :src="srcPlay"  controls class="w-100 mr-2 mt-1">
                                        </audio>

                                      </div>





                                      <div v-if="showFileUploader" class="d-flex justify-content-center w-100 px-5 my-1" >

                                        <div class="ar">
                                          <label>فایل را انتخاب کنید</label>

                                          <b-form-file v-model="action.new_issue.file" placeholder="فایل را انتخاب کنید" drop-placeholder="Drop file here..."
                                                       plain>
                                          </b-form-file>
                                          <!--                                                          <div class="text-center my-2" v-if="action.new_issue.file">-->
                                          <!--                                                              <b-form-checkbox v-model="action.new_issue.fileLib"  :disabled="IssueAsForum" name="check-button" switch class="d-inline" ></b-form-checkbox>-->
                                          <!--                                                              <span  class="mr-1"  style="color: #e65100">انتشار فایل در کتابخانه</span>-->
                                          <!--                                                          </div>-->
                                        </div>

                                      </div>




                                      <div v-if="showImageUploader" class="d-flex justify-content-center w-100 px-5 my-1">

                                        <div class="ar " >
                                          <label>تصویر را انتخاب کنید</label>
                                          <!-- <ckeditor value="Hello, World!"></ckeditor> -->
                                          <!--                                                    <ckeditor id="editor"  v-model="editorData" :config="editorConfig"></ckeditor>-->
                                          <b-form-file v-model="action.new_issue.image" placeholder="تصویر را انتخاب کنید" drop-placeholder="Drop file here..." plain>
                                          </b-form-file>

                                          <!--                                                    <input type="file" class="" ref="file" @change="onFileChangeImage($event)"-->
                                          <!--                                                           placeholder="تصویر را انتخاب کنید"/>-->


                                        </div>

                                      </div>



                                      <div v-if="showVideoUploader" class="d-flex justify-content-center w-100 px-5 my-1">

                                        <div class="ar" >
                                          <label>ویدئو را انتخاب کنید</label>
                                          <!-- <ckeditor value="Hello, World!"></ckeditor> -->
                                          <!--                                                    <ckeditor id="editor"  v-model="editorData" :config="editorConfig"></ckeditor>-->
                                          <b-form-file  v-model="action.new_issue.video" placeholder="ویدئو را انتخاب کنید" drop-placeholder="Drop file here..." plain>
                                          </b-form-file>
                                        </div>

                                      </div>





                                    </div>

                                    

                                    <div>

                                      <b-collapse id="collapse-1" class="mt-2 text-right">
                                        <b-card style="color: #555">
                                          <!--                                                          <b-form-select v-model="selected" :options="typeOptions" size="sm" class="mt-3"></b-form-select>-->



                                          <b-row  v-if="action.new_issue.title">


                                            <b-col  md="6" class="mb-2">

                                              <small> فرایند:</small>
                                              <b-form-select  size="sm" style="direction: ltr"
                                                              v-model="action.new_issue.process_id"
                                              >
                                                <b-form-select-option  v-for="(process, processIndex) in processes" :key="processIndex"
                                                                       :value="process.id"  >
                                                  {{process.title}}
                                                </b-form-select-option>

                                              </b-form-select>
                                            </b-col>
                                            <b-col  md="6" class="mb-2" >

                                              <small> مرحله:</small>
                                              <b-form-select  size="sm" style="direction: ltr"
                                                              v-model="action.new_issue.step_id"
                                              >
                                                <b-form-select-option  v-for="(step, stepIndex) in steps" :key="stepIndex"   :value="step.id" >
                                                  {{step.title}}
                                                </b-form-select-option>

                                              </b-form-select>
                                            </b-col>



                                            <b-col  md="3">
                                              <small> زمان شروع:</small>
                                              <custom-time-picker  v-model="action.new_issue.start_date"
                                                                   type="datetime" :clearable="true" placeholder="زمان شروع" min="" max="">
                                              </custom-time-picker>
                                            </b-col>
                                            <b-col  md="3">
                                              <small> زمان انجام:</small>
                                              <custom-time-picker  v-model="action.new_issue.done_date"
                                                                   type="datetime" :clearable="true" placeholder="زمان انجام" min="" max="">
                                              </custom-time-picker>
                                            </b-col>

                                            <b-col  md="3" >
                                              <small> مدت تخمینی:</small>
                                              <b-input
                                                  v-model="action.new_issue.estimated_time"
                                                  placeholder="مدت تخمینی"
                                                  type="number"
                                              ></b-input>
                                            </b-col>

                                            <b-col  md="3" >
                                              <small> درصد پیشرفت:</small>
                                              <b-input
                                                  v-model="action.new_issue.progress_input"
                                                  placeholder="درصد پیشرفت"
                                                  type="number"
                                              ></b-input>
                                            </b-col>



                                            <b-col  md="12" class="mt-2">

                                              <multiselect  v-model="action.new_issue.tags" :height="300" :options="options" :multiple="true"
                                                            :taggable="true" :close-on-select="false" :clear-on-select="false"
                                                            :custom-label="customLabel"
                                                            :preserve-search="true" :hide-selected="true" :show-labels="false"
                                                            tag-placeholder="افزودن تگ جدید" placeholder="برچست (تگ)"
                                                            label="title" track-by="title" :preselect-first="false"

                                                            @tag="addTag">
                                              </multiselect>
                                            </b-col>
                                          </b-row>






                                        </b-card>
                                      </b-collapse>
                                    </div>

                                    
                                  </b-col>
                                </b-row>
                              </td>

                              
                              <td v-else></td>


                                <td>
                                        <span @click="deleteActions(actionIndex)">
                                             <i class="fa fa-times"></i>
                                        </span>
                                </td>
                            </tr>

                            </tbody>
                        </table>




                    </div>
                    <div class="modal-footer">
                        <!--                                <button type="button" class="btn btn-default"-->
                        <!--                                        data-dismiss="modal">{{ $t('Close') }}</button>-->
                        <button class="btn btn-primary" data-dismiss="modal"
                                @click="updateActions(item.id)" >بروزرسانی عملیات</button>
                    </div>



                </div>






            </b-modal>










        </div>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }
    };


    import Multiselect from 'vue-multiselect'


    export default {
        components: {

            Multiselect,

        },
        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                items: [],
                loader:false,





                fields:[],
                conditions:[],
                actions:[],

                users:[],
                assignOptions:[],

              options:[],

              contacts: [],
              projects: [],

              steps: [],
              orders: [],
              processes: [],

              types: [],

              showVoiceRecorder: false,
              showFileUploader: false,
              showImageUploader: false,
              showVideoUploader: false,

              src: null,
              srcPlay: null,


              processId: '',

            }
        },

      beforeRouteUpdate(to, from, next) {
        if (to.params.id && to.params.id != 'null')
          this.processId = to.params.id
        next();
      },

        mounted() {
          if (this.$route.params.id && this.$route.params.id != 'null')
             this.processId = this.$route.params.id

            this.getFlows()

            this.getFields()
            this.getUsers()

          this.getTypes()
          this.getProcesses()
          this.getSteps(this.processId)
          this.getOrders()
          this.getContacts()
          this.getProjects()
          this.getTags()

        }


        ,
        methods: {

          getFlows(){
            this.loader=true
            this.getSteps(this.processId)

            axios
                .get(`/api/flows?process_id=`+this.processId, this.auth)

                .then(response => {
                  this.items = response.data.data;
                  console.log(this.items,"issueType");
                  this.loader=false

                })
                .catch(error => {
                  this.loader = false
                  if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                    this.$snotify.warning(rgis.$t('Your access to this section is restricted'));
                  } else {
                    this.$snotify.warning(error.response.data.message);
                  }
                  console.log(error);
                  this.errored = true
                })
                .finally(() => this.loading = false)





          },
            spliceNumber(number) {
                //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

                $("input[data-type='number']").keyup(function (event) {
                    var $this = $(this);
                    var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
                    $this.val(num2);
                });
                if (number !== null) {
                    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                }

            },



            pagnation(api) {
                // console.log(api,"m")
                axios.get(api, this.auth)
                    .then(response => {
                        // this.current_page = response.data.current_page
                        this.items = response.data.data;
                        //  console.log(response.data.data)
                        // this.pagnationDate = response.data
                        //  console.log(this.pagnationDate)
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            deleteEntry(id, index) {
                if (confirm(this.$t('Are you sure you want to delete the item?'))) {
                    var app = this;
                    axios.delete(`/api/flows/` + id, app.auth)
                        .then(function (resp) {
                            app.items.splice(index, 1);
                        })
                        .catch(function (resp) {
                            alert(this.$t('Cannot delete item'));
                        });
                }
            },
            filteritem(item) {

                if (item == 1) {
                    return  this.$t('Active')
                } else {
                    return  this.$t('Inactive')
                }
            },

            filteritemType(item) {



                switch (item) {
                    case '1':
                        return  this.$t('In the process of payment')
                        break;
                    case '2':
                        return this.$t('pay')
                        break;
                    case '3':
                        return  this.$t('revoked')
                        break;
                    default:
                        return  this.$t('In the process of payment')
                }



            },




            getRelation(id) {
                // axios.get('/api/payment/CustomerPayment/' + id, this.auth)
                //     .then(function (resp) {
                //         console.log(resp.data.data.id);
                //         return resp.data.data.id;
                //     })
                //     .catch(function (resp) {
                //         return this.$t('Unknown') ;
                //     });
            },





            tableToExcel (table, name) {

                var uri = 'data:application/vnd.ms-excel;base64,'
                    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
                    , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
                    , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }


                if (!table.nodeType) table = document.getElementById(table)
                var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
                window.location.href = uri + base64(format(template, ctx))

            },



            issueTypeText(issueType) {
                if (issueType.type == 1)
                    return 'سرنخ (Lead)'
                else if (issueType.type == 2)
                    return 'فرصت (Opportunity)'
                else if (issueType.type == 3)
                    return 'ملاقات/جلسه/رویداد'
                else if (issueType.type == 4)
                    return 'پیگیری (Ticket)'
                else if (issueType.type == 5)
                    return 'ایراد (Bug)'
                else if (issueType.type == 6)
                    return 'فعالیت (Task)'
                else if (issueType.type == 7)
                    return 'لیست/شرح (Story)'
                else if (issueType.type == 8)
                    return 'مجموعه/امکانات (Epic)'
                else if (issueType.type == 9)
                    return 'پیام/تلفن (Message)'
                else if (issueType.type == 10)
                    return 'گزارش/خبر (Report)'
                else if (issueType.type == 11)
                    return 'سایر'
                else
                    return 'سایر'
            },





          pluck(array, key) {
            return array.map(function (obj) {
              return obj[key];
            });
          },



          onResult (data) {
//                console.log('The blob data:', data);
//                console.log('Downloadable audio', window.URL.createObjectURL(data));
            this.srcPlay =  window.URL.createObjectURL(data)
            this.src =  data

          },









            getFields(){

                axios.get('/api/fieldList', this.auth)
                    .then(response => {
                        console.log(response.data);

                        this.fields = response.data;

                        // this.fields.forEach(function (element) {
                        //     element.number = "1";
                        // });
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false);

            },











            manageConditions(id){
                this.$bvModal.show('conditions-manage-'+id)
                this.conditions = []
                this.actions = []
                this.getConditions(id)
                this.getActions(id)

            },


            addConditions(){

                this.conditions.push({
                    field_id: '',
                    // price: 0,
                    // initial_amount: 1,
                    // note:'',
                    state:1,

                });

            },

            deleteConditions(key){

                this.conditions.splice(key,key);


            },

            getConditions(id){

                let app = this;
                axios.get('/api/flow/conditions/'+ id, app.auth)
                    .then(response => {
                        console.log('conditions',response.data)
                        app.conditions = response.data.data;
                    })
                    .catch(error => {
                        console.log(error);
                    })

            },

            updateConditions(id){

                let app = this;

                let data =
                    {
                        conditions: app.conditions
                    }
                axios.post('/api/flow/conditions/'+ id, data , app.auth)
                    .then(response => {
                        app.$snotify.success(app.$t('Item saved successfully'));

                        app.getConditions(id)
                    })
                    .catch(error => {
                        console.log(error);
                        app.$snotify.error('خطا در بروزرسانی شرط ها');

                    })

            },








            addActions(){

                this.actions.push({
                    field_id: '',
                    // price: 0,
                    // initial_amount: 1,
                    // note:'',
                    state:1,
                    new_issue: {
                    intro:'',
                    state:'0',
                    title:'',
                    text:'0',


                    progress_input:'',

                    voice:'',
                    file:'',
                    image:'',
                    video:'',

                    news:0,
                    course_id:null,
                    course_category_id:null,
                    forum_id:null,
                    forum_category_id:null,
                    tagsArray:[],
                    // issue_likes:null,
                    // userLike:null,

                    type:'4',
                    project_id:null,
                    process_id:'',
                    board_id:2,
                    users:[],
                    oldUsers:[],

                    priority:2,
                    start_date:null,
                    done_date:null,
                    tags:[],

                    // parent_id:null

                  },


                });

            },

            deleteActions(key){

                this.actions.splice(key,key);


            },

            getActions(id){

                let app = this;
                axios.get('/api/flow/actions/'+ id, app.auth)
                    .then(response => {
                        console.log('actions',response.data)
                        app.actions = response.data.data
                    })
                    .catch(error => {
                        console.log(error);
                    })

            },

            updateActions(id){

                let app = this;

                let data =
                    {
                        actions: app.actions
                    }
                axios.post('/api/flow/actions/'+ id, data , app.auth)
                    .then(response => {
                        app.$snotify.success(app.$t('Item saved successfully'));

                        app.getActions(id)
                    })
                    .catch(error => {
                        console.log(error);
                        app.$snotify.error('خطا در بروزرسانی شرط ها');

                    })

            },



            getUsers(){
                var app = this;
                axios.get('/api/userslist', app.auth)
                    .then(function (response) {
                        app.users = response.data

                        // console.log('users',response.data)


                        for (const key in app.users) {
                            if (app.users.hasOwnProperty(key)) {
                                const element = app.users[key];

                                app.assignOptions.push({
                                    name: '@'+element.name,
                                    id: element.id
                                })
                            }
                        }

                        app.setOwnUserAssign()

                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

          customLabel(option) {

            return `${option.title}`

          },

          addTag(newTag) {
            this.options.push({
              title: '#'+newTag,
              id: 0
            })
          },



          customLabelAssign(option) {

                return `${option.name}`

            },
            addAssign (newTag) {

                this.assignOptions.push({
                    name: '@'+newTag,
                    id: 0
                })
            },







          typeBadgeStyles(issueType){
            if (issueType.type == 1)
              return '#880e4e'
            else if (issueType.type == 2)
              return '#f50057'
            else if (issueType.type == 3)
              return '#8e24aa'
            else if (issueType.type == 4)
              return '#263238'
            else if (issueType.type == 5)
              return '#dd2c00'
            else if (issueType.type == 6)
              return '#00c853'
            else if (issueType.type == 7)
              return '#0097a7'
            else if (issueType.type == 8)
              return '#0288d1'
            else if (issueType.type == 9)
              return '#0208ff'
            else if (issueType.type == 10)
              return '#eeb600'
            else if (issueType.type == 10)
              return '#0e8e2e'
            else
              return '#888888'
          },






          getTypes(){
            var app = this;
            axios.get('/api/issueTypeList', app.auth)
                .then(function (response) {
                  app.types = response.data
                })
                .catch(function (e) {
                  console.log(e.response);
                });
          },

          getProcesses(){
            var app = this;
            axios.get('/api/intro/processes', app.auth)
                .then(function (response) {
                  app.processes = response.data.data.data
                })
                .catch(function (e) {
                  console.log(e.response);
                });
          },

          getSteps(processID = null){
            var app = this;
            axios.get('/api/intro/steps/'+processID ,  app.auth)
                .then(function (response) {
                  app.steps = response.data.data.data
                })
                .catch(function (e) {
                  console.log(e.response);
                });
          },

          getOrders(){

            axios.get('/api/orders', this.auth)
                .then(response => {
                  // this.current_page = response.data.current_page
                  this.orders = response.data.data;
                  console.log(response.data.data)
                  // this.pagnationDate = response.data
                  // console.log(this.pagnationDate)
                  // this.loader = false
                })
                .catch(error => {
                  // this.loader = false
                  console.log(error);
                })
          },

          getContacts(){

            axios.get('/api/contactslist', this.auth)
                .then(response => {
                  // this.current_page = response.data.current_page
                  this.contacts = response.data;
                  // this.pagnationDate = response.data
                  // console.log(this.pagnationDate)
                  // this.loader = false

                  this.makeContactOptions()

                })
                .catch(error => {
                  // this.loader = false
                  console.log(error);
                })
          },



          makeContactOptions(){
            var app = this;

            for (const key in app.contacts) {
              if (app.contacts.hasOwnProperty(key)) {
                const element = app.contacts[key];

                app.contactOptions.push({
                  value: element.id,
                  text: element.first_name+' '+element.last_name
                })
                // this.details[0].
              }
            }
            // console.log(app.contacts)
            // console.log(app.contactOptions)


          },

          getProjects() {
            axios
                .get('/api/projectList', this.auth)
                .then(response => {

                  this.projects = response.data;
                })
                .catch(error => {
                  console.log(error);
                  this.errored = true
                })
          },




          getTags(){
            var app = this;
            axios.get('/home/file/tagSearch/', app.auth)
                .then(function (response) {
                  app.fileCategories = response.data.data.tags.data

                  console.log(response.data.data.tags.data)


                  for (const key in app.fileCategories) {
                    if (app.fileCategories.hasOwnProperty(key)) {
                      const element = app.fileCategories[key];

                      app.options.push({
                        title: '#'+element.title,
                        id: element.id
                      })
                      // this.details[0].
                    }
                  }
                  // console.log(app.options)


                })
                .catch(function (e) {
                  console.log(e.response);
                });
          },







        },

















    }

</script>
<!--<script>-->
<!--export default {-->
<!--computed: {-->
<!--username() {-->
<!--// We will see what `params` is shortly-->
<!--return this.$route.params.username-->
<!--}-->
<!--},-->
<!--methods: {-->
<!--goBack() {-->
<!--window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')-->
<!--}-->
<!--}-->
<!--}-->
<!--</script>-->
